<template xmlns:b-row="http://www.w3.org/1999/html">
  <section id="agendador">
    <b-breadcrumb
      :items="breadcrumb"
    />

    <b-row>
      <b-col cols="12">
        <b-card-actions
          ref="filters"
          title="Editar Usuário"
          :action-close="false"
          :action-refresh="false"
          :action-collapse="true"
          @refresh="refreshStop('cardAction')"
        >
          <div
            v-if="isLoading"
            class="text-center"
          >
            <b-spinner />
          </div>
          <div v-else>
            <validation-observer ref="rulesUser">
              <b-row>
                <b-col :cols="inputCols">
                  <b-form-group
                    label="Nome"
                    label-for="name"
                  >
                    <validation-provider
                      #default="{ errors }"
                      rules="required"
                    >
                      <b-form-input
                        id="name"
                        v-model="client.name"
                        :disabled="isSubmiting"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col
                  :cols="inputCols"
                >

                  <b-form-group
                    label="E-mail"
                    label-for="email"
                  >
                    <validation-provider
                      #default="{ errors }"
                      rules=""
                    >
                      <b-input-group>
                        <b-form-input
                          id="email"
                          v-model="client.email"
                          :disabled="isSubmiting"
                          @blur="validateEmail"
                        />
                        <b-input-group-append
                          v-if="isValidatingEmail"
                        >
                          <b-button
                            variant="outline-secondary"
                            size="sm"
                          >
                            <b-spinner
                              small
                            />
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>

                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col :cols="inputCols">
                  <b-form-group
                    label="Tipo de Pessoa"
                    label-for="person_type"
                  >
                    <validation-provider
                      #default="{ errors }"
                      rules=""
                    >
                      <b-form-select
                        id="person_type"
                        v-model="client.person_type"
                        :options="crmPersonType"
                        :disabled="isSubmiting"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row v-if="client.person_type === 'pf'">
                <b-col :cols="inputCols">
                  <b-form-group
                    label="CPF"
                    label-for="cpf"
                  >
                    <validation-provider
                      #default="{ errors }"
                      rules=""
                    >
                      <cleave
                        v-model="client.cpf"
                        class="form-control"
                        placeholder=""
                        :options="maskCpf"
                        :disabled="isSubmiting"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row v-if="client.person_type === 'pj'">
                <b-col :cols="inputCols">
                  <b-form-group
                    label="CNPJ"
                    label-for="cnpj"
                  >
                    <validation-provider
                      #default="{ errors }"
                      rules=""
                    >
                      <cleave
                        v-model="client.cnpj"
                        class="form-control"
                        placeholder=""
                        :options="maskCnpj"
                        :disabled="isSubmiting"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row v-if="client.person_type === 'pj'">
                <b-col :cols="inputCols">
                  <b-form-group
                    label="Empresa"
                    label-for="company_name"
                  >
                    <validation-provider
                      #default="{ errors }"
                      rules=""
                    >
                      <b-form-input
                        id="name"
                        v-model="client.company_name"
                        :disabled="isSubmiting"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row v-if="client.person_type === 'pj'">
                <b-col :cols="inputCols">
                  <b-form-group
                    label="Posição na empresa"
                    label-for="position_in_company"
                  >
                    <validation-provider
                      #default="{ errors }"
                      rules=""
                    >
                      <b-form-input
                        id="name"
                        v-model="client.position_in_company"
                        :disabled="isSubmiting"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col :cols="inputCols">
                  <user-edit-phones
                    ref="userEditPhones"
                    :phones.sync="client.phones"
                    :user-id="client.id"
                    :is-submiting="isSubmiting"
                  />
                </b-col>
              </b-row>

              <b-row>
                <b-col :cols="inputCols">
                  <user-edit-emails
                    ref="UserEditEmails"
                    class="mt-2"
                    :emails.sync="client.emails"
                    :user-id="client.id"
                    :is-submiting="isSubmiting"
                  />
                </b-col>
              </b-row>

              <b-row>
                <b-col :cols="inputColsAdrress">
                  <user-edit-addresses
                    ref="UserEditAddresses"
                    class="mt-2"
                    :addresses.sync="client.addresses"
                    :user-id="client.id"
                    :is-submiting="isSubmiting"
                  />
                </b-col>
              </b-row>

              <b-row>
                <b-col
                  cols="12"
                  class="text-right"
                >
                  <b-button
                    class="ml-2 text-right"
                    :disabled="isSubmiting"
                    @click="back"
                  >
                    Fechar
                  </b-button>

                  <b-button
                    class="ml-2 text-right"
                    :disabled="isSubmiting"
                    @click="save"
                  >
                    Salvar
                  </b-button>
                </b-col>
              </b-row>
            </validation-observer>
          </div>

        </b-card-actions>

      </b-col>
    </b-row>
  </section>
</template>

<script>
import {
  BSpinner,
  BBreadcrumb,
  BButton,
  BCol,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BInputGroup,
  BInputGroupAppend,
  BRow,
} from 'bootstrap-vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import CrmService from '@/services/crmService'
import UserEditPhones from '@/views/crm/user/UserEditPhones.vue'
import UserEditEmails from '@/views/crm/user/UserEditEmails.vue'
import UserEditAddresses from '@/views/crm/user/UserEditAddresses.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import toasts from '@/mixins/toast'
import swall from '@/mixins/swall'
import requestErrorMessage from '@/mixins/requestErrorMessage'
import { crmPersonType } from '@/utils/options'
import Cleave from 'vue-cleave-component'
import {
  maskCpf, maskCnpj,
} from '@/utils/masks'

export default {
  components: {
    BSpinner,
    BFormGroup,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormSelect,
    BButton,
    BCardActions,
    BRow,
    BCol,
    BBreadcrumb,
    UserEditPhones,
    UserEditEmails,
    UserEditAddresses,
    BInputGroup,
    BInputGroupAppend,
    Cleave,
  },
  mixins: [toasts, swall, requestErrorMessage],

  props: {
    clientId: {
      type: [String, Number],
      required: false,
      default: null,
    },
    accountId: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },

  data() {
    return {
      breadcrumb: [
        {
          text: 'Projetos',
          active: true,
        },
        {
          text: 'CRM',
          active: true,
        },
        {
          text: 'Editar Usuário',
          active: true,
        },
      ],
      crmPersonType,
      isSubmiting: false,
      isValidatingEmail: false,
      isLoading: false,
      isRemoving: false,
      client: {
        id: 0,
        account_id: null,
        name: null,
        email: '',
        phones: [],
        addresses: [],
        demographic: [],
        emails: [],
        person_type: '',
      },
      userData: null,
      maskCpf,
      maskCnpj,
    }
  },

  computed: {
    creatingUser() {
      return this.clientId !== null && this.clientId === 0
    },

    inputCols() {
      return this.inModal ? 10 : 8
    },

    inputColsAdrress() {
      return this.inModal ? 12 : 10
    },

    inModal() {
      return this.clientId !== null && this.$route.params.clientId === undefined
    },
  },

  created() {
    const userDataString = localStorage.getItem('userData')
    this.userData = JSON.parse(userDataString)

    this.showClient()
  },

  methods: {
    validateEmail() {
      if (this.client.email.length > 5) {
        const data = { email: this.client.email, account_id: this.accountId }

        this.isSubmiting = true
        this.isValidatingEmail = true
        CrmService.listClients(data).then(response => {
          const total = response.data.clients.data.filter(f => f.id !== this.client.id)
          if (total.length > 0) {
            if (this.type === 'user') {
              this.swallError('Atenção', 'E-mail digitado já tem conta no CRM, use o botão "Vincular Usuário"', 'OK')
            } else {
              this.swallError('Atenção', 'E-mail digitado já consta como cliente', 'OK')
            }
          }
        }).catch(error => {
          this.swallError('Erro!', error.response.data.message, 'Fechar')
        }).finally(() => {
          this.isSubmiting = false
          this.isValidatingEmail = false
        })
      }
    },

    back() {
      this.$emit('close', true)
    },

    editClient() {
      this.isSubmiting = true

      return CrmService.putClient(this.client).then(response => {
        if (response.data.client) {
          this.toastSuccess('Sucesso!', 'Cliente alterado!')
          this.showClient()
          this.$emit('saved', true)
        } else {
          this.swallError('Erro!', 'Não foi possível alterar o cliente', 'Fechar')
        }
      }).catch(error => {
        this.swallError('Erro!', error.response.data.message, 'Fechar')
      }).finally(() => {
        this.isSubmiting = false
      })
    },

    createClient() {
      this.isSubmiting = true

      return CrmService.postClient(this.client).then(response => {
        if (response.data.client) {
          this.toastSuccess('Sucesso!', 'Cliente criado!')
          this.showClient()
          this.$emit('saved', true)
        } else {
          this.swallError('Erro!', 'Não foi possível criar o cliente', 'Fechar')
        }
      }).catch(error => {
        this.swallError('Erro!', error.response.data.message, 'Fechar')
      }).finally(() => {
        this.isSubmiting = false
      })
    },

    save() {
      if (this.accountId) {
        this.client.account_id = this.accountId
      }

      return this.$refs.rulesUser.validate().then(success => {
        if (success) {
          if (this.client.id === 0) {
            this.createClient()
          } else {
            this.editClient()
          }
        } else {
          this.toastDanger('Erros de validação', 'Preencha todos os campos obrigatórios')
        }
      })
    },

    showClient() {
      const clientId = this.clientId ? this.clientId : this.$route.params.clientId
      if (clientId) {
        this.isLoading = true
        CrmService.showClient(clientId, { append: ['emails', 'phones', 'addresses'] }).then(response => {
          if (response.data !== null) {
            this.client = response.data.client
            if (this.client.emails) {
              this.client.emails = this.client.emails.filter(m2 => m2.main !== true)
            }
          }
        }).finally(() => {
          this.isLoading = false
        })
      }
    },
  },
}
</script>

<style lang="scss">
.line-through{
  text-decoration: line-through;
}
</style>
